<div class="form-actions">
  <button type="button" (click)="onCancel()" class="button-cancel">
    {{ cancelLabel | transloco }}
  </button>
  <button type="submit" class="button-save">
    {{ saveLabel | transloco }}
  </button>
</div>
